import {createYandexMapHelper} from '../../classes/yandex-map-helper/yandex-map-helper/init-yandex-map';
import {YMAPS_API_KEY, DURATION} from '../../classes/yandex-map-helper/constants';

const OVERLAY_COMPLEX_MANAGER_NAME = 'overlay-complex-manager';
const PLACEMARK_MANAGER_ID = 'placemark-manager';
let busRoute = null;
let busRoute2 = null;

let placemarksManager = null;
let overlayComplexManager = null;

const metro = [
	{
		mitino: {
			longitude: 55.846222,
			latitude: 37.361243
		}
	}
]

const busStations = [
	{
		longitude: 55.840322,
		latitude: 37.358276
	},
	{
		longitude: 55.847175,
		latitude: 37.361899
	},
	{
		longitude: 55.860898,
		latitude: 37.325745
	},
	{
		longitude: 55.862795,
		latitude: 37.312862
	}
];

const isBoundsCorrect = ( bounds ) => {
	return bounds && bounds[0] && bounds[1] && bounds[0][0] !== bounds[1][0] && bounds[0][1] !== bounds[1][1];
};

const setInitMapPosition = ( yandexMapHelper ) => {
	yandexMapHelper.yandexMap.setCenter(
		yandexMapHelper.initCenter,
		yandexMapHelper.initZoom,
		{
			duration: DURATION,
		},
	);
};

const applyBounds = ( yandexMapHelper ) => {
	const bounds = yandexMapHelper.yandexMap.geoObjects.getBounds();
	
	if ( isBoundsCorrect( bounds ) ) {
		yandexMapHelper.yandexMap.setBounds(
			bounds,
			{checkZoomRange: true, duration: DURATION, useMapMargin: false},
		)
			.then( () => {
				// yandexMapHelper.initCenter = yandexMapHelper.yandexMap.getCenter();
				
				if ( yandexMapHelper.component.getAttribute( 'data-type' ) === 'infrastructureMap' )
				{
					yandexMapHelper.yandexMap.setZoom( 14 );
					// setInitMapPosition( yandexMapHelper );
				}

				if ( yandexMapHelper.component.getAttribute( 'data-type' ) === 'roadMap' ) {
					yandexMapHelper.yandexMap.setZoom( 14 );
					// setInitMapPosition( yandexMapHelper );
				}

				if ( yandexMapHelper.component.getAttribute( 'data-type' ) === 'generalMap' ) {
					yandexMapHelper.yandexMap.setZoom( 11 );
					// setInitMapPosition( yandexMapHelper );
				}
				yandexMapHelper.initZoom = yandexMapHelper.yandexMap.getZoom();
			} );
	}
	else
	{
		// setInitMapPosition( yandexMapHelper );
	}
};

// Создание плейсмарок (метро, автобусы, точки инфраструктуры)

const initPlacemarks = ( yandexMapHelper ) => {
	placemarksManager = yandexMapHelper.createObjectManager( PLACEMARK_MANAGER_ID, {
		clusterize: false,
		zIndex: 1,
	} );

	const iconWidth = 48;
	const iconHeight = 48;

	busStations.forEach( ( bus, index ) => {
		const {longitude, latitude} = bus;

		const placemarkProps = {
			type: 'Feature',
			id: `bus-${index}`,
			typeId: 'bus',
			geometry: {
				type: 'Point',
				coordinates: [longitude, latitude],
			},
			properties: {
				hintContent: name,
			},
			options: {
				iconLayout: 'default#image',
				iconImageHref: '/styles/images/map/busPin.png',
				iconImageSize: [iconWidth, iconHeight],
				iconImageOffset: [-0.5 * iconWidth, -1 * iconHeight],
			},
		};

		placemarksManager.add( placemarkProps );
	} )

	metro.forEach( ( station, index ) => {
		const {longitude, latitude} = station.mitino;

		const placemarkPropsMetro = {
			type: 'Feature',
			id: `metro-${index}`,
			typeId: 'metro',
			geometry: {
				type: 'Point',
				coordinates: [longitude, latitude],
			},
			properties: {
				hintContent: name,
			},
			options: {
				iconLayout: 'default#image',
				iconImageHref: '/styles/images/map/metroPin.png',
				iconImageSize: [iconWidth, iconHeight],
				iconImageOffset: [-0.5 * iconWidth, -1 * iconHeight],
			},
		};

		placemarksManager.add( placemarkPropsMetro );
	} )

	const placemarksWrapper = yandexMapHelper.component.querySelector( 'ul.placemarks' );

	if ( !placemarksWrapper )
	{
		return;
	}

	const placemarkIconSize = 48;

	placemarksWrapper.querySelectorAll( 'li' ).forEach( ( placemarkNodeInfoWrapper ) => {		
		const balloonClass = 'infrastructure-placemark-balloon';
		
		const balloonTemplate = (
			`<div class="infrastructure-placemark-balloon-wrapper">
				<div class="${balloonClass}">
					<div class="icon"
						style="background-image: url(${placemarkNodeInfoWrapper.dataset.icon});"
					></div>
					<p class="info">
						${placemarkNodeInfoWrapper.dataset.title}
					</p>
				</div>
			</div>`
		);
		
		const placemarkProps = {
			type: 'Feature',
			id: placemarkNodeInfoWrapper.dataset.id,
			typeId: 'point',
			geometry: {
				type: 'Point',
				coordinates: [placemarkNodeInfoWrapper.dataset.latitude, placemarkNodeInfoWrapper.dataset.longitude],
			},
			properties: {
				balloonContent: placemarkNodeInfoWrapper.dataset.title,
			},
			options: {
				iconLayout: yandexMapHelper.ymaps.templateLayoutFactory.createClass(
					`<div class="infrastructure-placemark-wrapper"
						data-infrastructure-marker-id="${placemarkNodeInfoWrapper.dataset.id}"
						style="background-image: url(${placemarkNodeInfoWrapper.dataset.icon});"
					>
					</div>`,
				),
				iconOffset: [placemarkIconSize / -2, placemarkIconSize / -2],
				iconShape: {
					type: 'Rectangle',
					coordinates: [
						[0, 0],
						[placemarkIconSize, placemarkIconSize],
					],
				},
				iconSize: [placemarkIconSize, placemarkIconSize],
				iconImageOffset: [-1 * placemarkIconSize / 2, -1 * placemarkIconSize / 2],
				
				hideIconOnBalloonOpen: false,
				balloonShadow: false,
				balloonPanelMaxMapArea: 0,
				balloonAutoPanMargin: 0,
				balloonAutoPan: true,
				balloonLayout: yandexMapHelper.ymaps.templateLayoutFactory.createClass(
					balloonTemplate,
					{
						build() {
							this.constructor.superclass.build.call( this );
							
							const balloonSelector = `div.${balloonClass}`;
							const balloonWrapper = this.getElement().querySelector( balloonSelector );

							const icon = this.getElement().querySelector( `${balloonSelector} div.icon` );
							
							if ( icon )
							{
								const balloonClickHandler = () => {
									icon.removeEventListener( 'click', balloonClickHandler );
									yandexMapHelper.closeBalloon();
								};
								
								/* setTimeout добавлен из-за глюков яндекса - быстрого закрытия балуна */
								setTimeout(
									() => {
										balloonWrapper.addEventListener( 'click', balloonClickHandler );
									},
									100,
								);
							}
							
							if ( balloonWrapper )
							{
								const balloonWidth = balloonWrapper.offsetWidth;
								const balloonHeight = balloonWrapper.offsetHeight;
								const iconWidth = icon.offsetWidth;
								const iconHeight = icon.offsetHeight;
								
								const shapeCoordinates = [
									[iconWidth / -2, iconHeight / -2],
									[balloonWidth - ( iconWidth / 2 ), ( balloonHeight - ( iconHeight / 2 ) )],
								];
								
								const shapeRectangle = {
									type: 'Rectangle',
									coordinates: shapeCoordinates,
								};
								
								this.getData().options.set( 'shape', shapeRectangle );
								
								balloonWrapper.style.setProperty( 'position', 'absolute' );
								balloonWrapper.style.setProperty( 'left', `${iconWidth / -2}px` );
								balloonWrapper.style.setProperty( 'top', `${iconHeight / -2}px` );
							}
						},
					},
				),
				
				zIndex: 1,
			},
		};
		
		placemarksManager.events.add(
			'click',
			( evt ) => {
				const currentObjectId = evt.get( 'objectId' );
				
				if ( placemarksManager.objects.balloon.isOpen( currentObjectId ) )
				{
					placemarksManager.objects.balloon.close();
				}
			},
		);
		
		placemarksManager.add( placemarkProps );
	} );

	if ( yandexMapHelper.component.getAttribute( 'data-type' ) === 'infrastructureMap' )
	{
		placemarksManager.setFilter( ( object ) => object.typeId === 'point' );
	}
}

// Создание оверлеев для разных фильтров

const initOverlayComplex = ( yandexMapHelper, type = 'infrastructure' ) => {
	overlayComplexManager = yandexMapHelper.createObjectManager( OVERLAY_COMPLEX_MANAGER_NAME, {} );

	let overlay = '';
	let overlayCoords = null;

	switch( type )
	{
		case 'infrastructureMap':
			{
				overlay = '/styles/images/map/angelovoOverlayInfrastructure.svg';
				overlayCoords = [['55.862380', '37.316307'], ['55.853452', '37.334143']];
				break
			}
		case 'roadMap':
			{
				overlay = '/styles/images/contacts/angelovoOverlay.svg';
				overlayCoords = [['55.860909', '37.316610'], ['55.853604', '37.334407']];
				break
			}
		case 'generalMap':
			{
				overlay = '/styles/images/map/angelovoLogoOverlay.svg';
				overlayCoords = [['55.871475', '37.300586'], ['55.848349', '37.343724']];
				break
			}
		default:
			{
				overlay = '/styles/images/map/angelovoOverlayInfrastructure.svg';
				overlayCoords = [['55.862380', '37.316307'], ['55.853452', '37.334143']]; 
				break
			}
	}

	const overlayComplexProps = {
		type: 'Feature',
		id: `overlay-image-${type}`,
		geometry: {
			type: 'Rectangle',
			coordinates: overlayCoords,
		},
		properties: {},
		options: {
			hideIconOnBalloonOpen: true,
			balloonShadow: false,
			balloonPanelMaxMapArea: 0,
			openBalloonOnClick: false,
	
			fillImageHref: overlay,
			fillMethod: 'stretch',
			stroke: false,
	
			visible: false,
			zIndex: 0,
			cursor: 'default',
		},
	};

	overlayComplexManager.add( overlayComplexProps );
}

// Добавление маршрута от остановок до метро

const initBusPath = ( yandexMapHelper ) => {
	initPlacemarks( yandexMapHelper );
	yandexMapHelper.ymaps.route(
        [
            {type: 'wayPoint', point: [55.860898, 37.325745]},
            {type: 'wayPoint', point: [55.840322, 37.358276]},
        ],
        {
            wayPointVisible: false,
            mapStateAutoApply: false,
			multiRoute: false,
			routingMode: 'pedestrian',
        },
    )
        .then( ( route ) => {
            if ( busRoute )
            {
                yandexMapHelper.yandexMap.geoObjects.remove( busRoute );
            }

            busRoute = route;

			busRoute.options.set( {
						routeStrokeColor: '#0048BD',
						routeActiveStrokeColor: '#0048BD',
						viaPointIconFillColor: '#0048BD',
						viaPointActiveIconFillColor: '#0048BD',
						wayPointStartIconColor: '#0048BD',
						wayPointStartIconFillColor: '#0048BD',
						pinIconFillColor: '#0048BD',
						pinActiveIconFillColor: '#0048BD',
						routeStrokeStyle: 'dash',
						routeActivePedestrianSegmentStrokeStyle: 'dash',
						routeStrokeWidth: 2,
						routeOpacity: 1,
						wayPointVisible: false,
						routeOpenBalloonOnClick: false,
						routeActiveMarkerVisible: false,
					} );

            yandexMapHelper.yandexMap.geoObjects.add( busRoute );
        } );

	yandexMapHelper.ymaps.route(
		[
			{type: 'wayPoint', point: [55.861137, 37.325545]},
            {type: 'wayPoint', point: [55.847175, 37.361899]},
		],
        {
            wayPointVisible: false,
            mapStateAutoApply: false,
			multiRoute: false,
			routingMode: 'pedestrian',
        },
    )
        .then( ( route ) => {
            if ( busRoute2 )
            {
                yandexMapHelper.yandexMap.geoObjects.remove( busRoute2 );
            }

            busRoute2 = route;

			busRoute2.options.set( {
						routeStrokeColor: '#0048BD',
						routeActiveStrokeColor: '#0048BD',
						viaPointIconFillColor: '#0048BD',
						viaPointActiveIconFillColor: '#0048BD',
						wayPointStartIconColor: '#0048BD',
						wayPointStartIconFillColor: '#0048BD',
						pinIconFillColor: '#0048BD',
						pinActiveIconFillColor: '#0048BD',
						routeStrokeStyle: 'dash',
						routeActivePedestrianSegmentStrokeStyle: 'dash',
						routeStrokeWidth: 2,
						routeOpacity: 1,
						wayPointVisible: false,
						routeOpenBalloonOnClick: false,
						routeActiveMarkerVisible: false,
					} );

            yandexMapHelper.yandexMap.geoObjects.add( busRoute2 );
        } );
}

// Добавление возможности построение маршрута для контактов

const onChangeRoutesFilters = ( yandexMapHelper ) => {
	const mapComponent = document.querySelector( 'section.contacts' );

	const busSchedule = mapComponent.querySelector( 'div.info' );
	const filters  = mapComponent.querySelectorAll( 'button.filter' );

	if ( !filters.length )
	{
		return;
	}

	mapComponent.addEventListener( 'click', ( {target} ) => {
		if ( target.closest( 'button.filter' ) )
		{
			const activeMode = target.closest( 'button.filter' ).getAttribute( 'data-infrastructure-type' );

			filters.forEach( ( filter ) => filter.classList.remove( 'active' ) );

			target.closest( 'button.filter' ).classList.add( 'active' );

			if ( activeMode === 'car' )
			{
				placemarksManager.setFilter( ( object ) => object.typeId !== 'bus' && object.typeId !== 'metro' );

				yandexMapHelper.yandexMap.geoObjects.remove( busRoute );
				yandexMapHelper.yandexMap.geoObjects.remove( busRoute2 );

				busSchedule.style.display = 'none';
				
				yandexMapHelper.yandexMap.controls.add( 'routePanelControl', {
					float: 'none',
					position: {
						top: '150px',
						right: '30px',
					}
				} )

				const control = yandexMapHelper.yandexMap.controls.get('routePanelControl');

				control.routePanel.state.set({
					type: 'auto',
					toEnabled: false,
					fromEnabled: true,
					to: [55.856512, 37.321659]
				});

				control.routePanel.options.set({
					allowSwitch: false,
					reverseGeocoding: true,
				});
			}
			else
			{
				initBusPath( yandexMapHelper );

				yandexMapHelper.yandexMap.controls.remove( 'routePanelControl' );

				busSchedule.style.display = 'block';
			}
		}
	} )
}

// Функционал переключения фильтров

const onChangeFilters = ( map, yandexMapHelper ) => {
	const filters  = map.querySelectorAll( 'button.filter' );

	if ( !filters.length )
	{
		return;
	}

	map.addEventListener( 'click', ( {target} ) => {
		if ( target.closest( 'button.filter' ) )
		{
			const targetBtn = target.closest( 'button.filter' );
			const type = targetBtn.getAttribute('data-type');

			filters.forEach( ( filter ) => filter.classList.remove( 'active' ) );
			
			targetBtn.classList.add( 'active' );

			placemarksManager.setFilter( () => false );
			
			if ( type === 'roadMap' )
			{
				initBusPath( yandexMapHelper );

				overlayComplexManager.setFilter(() => false)
				placemarksManager.setFilter( ( object ) => object.typeId !== 'point' );
				applyBounds( yandexMapHelper );
				initOverlayComplex( yandexMapHelper, type );

				yandexMapHelper.component.setAttribute( 'data-type', type )
			}
			else if ( type === 'infrastructureMap' )
			{
				overlayComplexManager.setFilter(() => false)
				initOverlayComplex( yandexMapHelper, type );
				placemarksManager.setFilter( ( object ) => object.typeId === 'point' );
				yandexMapHelper.yandexMap.geoObjects.remove( busRoute );
				yandexMapHelper.yandexMap.geoObjects.remove( busRoute2 );
				applyBounds( yandexMapHelper );

				yandexMapHelper.component.setAttribute( 'data-type', type )
			}
			else if ( type === 'generalMap' )
			{
				overlayComplexManager.setFilter(() => false)
				initOverlayComplex( yandexMapHelper, type );
				if ( placemarksManager )
				{
					placemarksManager.setFilter( () => false );
				}
				yandexMapHelper.yandexMap.geoObjects.remove( busRoute );
				yandexMapHelper.yandexMap.geoObjects.remove( busRoute2 );
				applyBounds( yandexMapHelper );

				yandexMapHelper.component.setAttribute( 'data-type', type )
			}
		}
	} )
}
 
// инициализация карты и вызов всех рендер-методов

const initMap = ( yandexMapHelper ) => {
	const zoomPositionTop = yandexMapHelper.component.classList.contains( 'contacts' ) ? 512 : 356;

	yandexMapHelper.addZoomControls( {
		position: {
			top: zoomPositionTop,
			right: 20,
			bottom: 'auto',
			left: 'auto',
		},
	} );
	yandexMapHelper.setCorrectScrolling();

	onChangeFilters( yandexMapHelper.component, yandexMapHelper );
	
	const mapWrapper = yandexMapHelper.component.querySelector( 'div.map' );
	
	if ( !mapWrapper )
	{
		return;
	}
	
	if ( yandexMapHelper.component.classList.contains( 'contacts' ) )
	{
		initOverlayComplex( yandexMapHelper, 'roadMap' );
		initBusPath( yandexMapHelper );
		onChangeRoutesFilters( yandexMapHelper );
	}
	else
	{
		initOverlayComplex( yandexMapHelper );
	}

	initPlacemarks( yandexMapHelper );
};

const initStylizedYandexMap = ( component ) => {
	const mapContainer = component?.querySelector( 'div.map-wrapper > div.map' );

	let zooms = 14;
	let coords = [55.856512, 37.321659]; 

	if ( component.classList.contains( 'contacts' ) )
	{
		zooms = 14;
		coords = [55.851559, 37.338888]; 
	}
	
	if ( mapContainer )
	{	
		const mapProps = {
			ymapsApiKey: YMAPS_API_KEY,
			mapContainer,
			mapState: {
				center: coords,
				zoom: zooms,
			},
			component,
			readyCallback: initMap,
		};
		
		createYandexMapHelper( mapProps );
	}
}

export {
	initStylizedYandexMap,
}
